export default __webpack_public_path__ + "72a77e2.png";